import { connect } from 'react-redux'
import ChoosePrintType from '../present/ChoosePrintType.jsx';
import toJS from '../../../containers/general/toJS.js';
import { CLI_MULTICINEMA_MODE, PROGRAM_ATTRIBUTES } from '../../../constants/state.js';
import getData from '../../../functions/getData.js';
import chooseCinemasActive from '../functions/chooseCinemasActive.js';
import { printDataUpdateRequest, updateAttributeSettings } from '../../../actions/index.js';
import deleteSpecialCharacters from '../../../functions/deleteSpecialCharacters.js';

const getMissingAttributes = (cinemaAttributes, printData) => {
    if(!cinemaAttributes || !cinemaAttributes.technical || !printData.generalSettings || !printData.generalSettings.attributeColorSettings) {
        return null
    }

    const attributeColorSettings = printData.generalSettings.attributeColorSettings
    const colorSettingsIds = _.keys(attributeColorSettings)
    const technicalIds = _.keys(cinemaAttributes.technical)
    const differenceIds = _.difference(technicalIds, colorSettingsIds)
    const filteredTechnicals = {}

    differenceIds.map(id => {
        const idWithoutSpecialChars = deleteSpecialCharacters(id)
        if(!attributeColorSettings[idWithoutSpecialChars] && !filteredTechnicals[id]) {
            const technicalData = cinemaAttributes.technical[id]
            filteredTechnicals[idWithoutSpecialChars] = {
                id: idWithoutSpecialChars,
                name: technicalData.name,
                attributeColorSetting: {
                    color: null,
                    display: 'border',
                    hide: false,
                    iconUrl: null
                }
            }
        }
    })

    return filteredTechnicals

}

const mapStateToProps = state => ({
    webToPrintRoutes: state.getIn(['wpServerData', 'data', 'data', 'webtoprint']),
    multicinemaMode: getData(state, CLI_MULTICINEMA_MODE),
    printData: state.getIn(['printData']),
    attributes: getData(state, PROGRAM_ATTRIBUTES)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: (itemData) => {
        dispatch(updateAttributeSettings(itemData))
        dispatch(printDataUpdateRequest())
    },
    addItem: (itemData, attributeColorSettings) => {
        if(!attributeColorSettings[itemData.id]) {
            attributeColorSettings[itemData.id] = itemData
            dispatch(updateAttributeSettings(attributeColorSettings))
            dispatch(printDataUpdateRequest())
        }
    },
    removeItem: (id, attributeColorSettings) => {
        delete attributeColorSettings[id]
        dispatch(updateAttributeSettings(attributeColorSettings))
        dispatch(printDataUpdateRequest())

    }
})

const ChoosePrintTypeContainer = ({
    webToPrintRoutes, 
    multicinemaMode,
    match,
    goBackPath,
    printData,
    altGoBackPath,
    addItem,
    removeItem,
    onUpdateItem,
    attributes
}) => {
    let usedWebToPrintRoutes = []
    const closePagePath = chooseCinemasActive(multicinemaMode) ? altGoBackPath : goBackPath

    if(webToPrintRoutes) {
        _.keys(webToPrintRoutes).map((route) => {
            if((webToPrintRoutes[route] === 'true' || webToPrintRoutes[route] === true ) && route != 'newsletter') {
                usedWebToPrintRoutes.push(route)
            }
        })
    }

    const cinemaAttributes = match.params.cinemaId && attributes[match.params.cinemaId] ? attributes[match.params.cinemaId] : null
    const filteredTechnicals = getMissingAttributes(cinemaAttributes, printData)

    return (
        <ChoosePrintType
            usedWebToPrintRoutes={usedWebToPrintRoutes}
            onUpdateItem={onUpdateItem}
            removeItem={removeItem}
            addItem={addItem}
            basicUrl={match.url}
            filteredTechnicals={filteredTechnicals}
            attributeColorSettings={printData.generalSettings && printData.generalSettings.attributeColorSettings}
            closePagePath={closePagePath}
        />
    )
}

export default connect(mapStateToProps, mapDispatchToProps)(toJS(ChoosePrintTypeContainer))